import { ButtonRadio, Checkbox, Trans } from '@/components'
import { MachineType } from '@/consts/machine'

interface AcceleratorTypeSelectorProps {
  value: MachineType
  onChange: (value: MachineType) => void
  isVgpuChecked: boolean
  onVgpuCheckedChange: (checked: boolean) => void
}

export function AcceleratorTypeSelector({
  value,
  onChange,
  isVgpuChecked,
  onVgpuCheckedChange,
}: AcceleratorTypeSelectorProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-secondary t-sb">
        <Trans i18nKey="create.typeLabel">Accelerator Type</Trans>
      </div>
      <div className="flex gap-2">
        <ButtonRadio
          value={value}
          items={[
            {
              label: 'GPU',
              value: MachineType.GPU,
            },
            {
              label: 'CPU',
              value: MachineType.CPU,
            },
          ]}
          onChange={onChange}
        />
        {value === MachineType.GPU && (
          <div className="flex h-11 py-3 pr-4 pl-3 justify-center items-center gap-2 rounded-lg border border-neutral-200">
            <Checkbox className="t-sb" checked={isVgpuChecked} onChange={onVgpuCheckedChange}>
              <Trans i18nKey="create.typeLabelVGPU">vGPUs</Trans>
            </Checkbox>
          </div>
        )}
      </div>
    </div>
  )
}
